import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxurybusrentalinpune() {



  const cardData = {
"keyword": "Luxury Bus Rental in Pune",

"headingDescription":
  "Aaradhya Travels offers premium Luxury Bus Rental in Pune for corporate tours, weddings, group travel, airport transfers, pilgrimage journeys, and outstation trips. Our luxury buses are equipped with pushback reclining seats, air-conditioning, ambient interiors, music systems, and ample luggage space to ensure a comfortable and premium travel experience. With experienced drivers and well-maintained fleets, we provide safe, smooth, and stylish group transportation across Pune and Maharashtra.",

"topPlaces": [
   {
    "title": "Mumbai",
    "description": "Mumbai is a major metro city near Pune, popular for business trips, tourism, beaches, and weekend travel."
  },
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar is a famous hill destination near Pune offering cool weather, strawberry farms, viewpoints, and refreshing monsoon scenery."
  },
   {
    "title": "Lavasa City",
    "description": "Lavasa is a planned hill city near Pune featuring lakeside views, colorful architecture, and a peaceful environment for short holidays."
  },
  {
    "title": "Nashik",
    "description": "Nashik is a historic city near Pune known for vineyards, temples, and the sacred Trimbakeshwar Jyotirlinga shrine."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort near Pune is a historic hill fort offering trekking routes and panoramic views of the Sahyadri mountains."
  },
   
  {
    "title": "Shirdi",
    "description": "Shirdi is a major pilgrimage town near Pune dedicated to Sai Baba, attracting devotees throughout the year for spiritual visits."
  },
   {
    "title": "Lonavala",
    "description": "Lonavala is a popular hill station near Pune known for scenic valleys, waterfalls, and weekend getaways, perfect for group and family trips."
  },
  {
    "title": "Karla Bhaja Caves",
    "description": "Karla and Bhaja Caves near Pune are ancient Buddhist rock-cut caves known for historical significance and architectural beauty."
  },
  {
    "title": "Pawna Lake",
    "description": "Pawna Lake near Lonavala is a popular camping destination offering lakeside stays, bonfires, and adventure activities."
  },
  {
    "title": "Khandala",
    "description": "Khandala is a scenic hill station close to Lonavala, famous for valleys, viewpoints, and monsoon landscapes."
  }
],



services: [
  {
    name: "Luxury Bus Rental in Pimpri Chinchwad",
    description: "Luxury bus rental in Pimpri Chinchwad service provides premium transportation for corporate events, family vacations, airport transfers, wedding travel, and outstation journeys. Spacious luxury buses with comfortable seating and modern interiors ensure smooth travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from residential societies, offices, hotels, and commercial locations across Pimpri Chinchwad Pune. Flexible booking options allow convenient luxury bus reservations."
  },
  {
    name: "Luxury Bus Rental in Kharadi",
    description: "Luxury bus rental in Kharadi service offers dependable premium transportation for IT professionals, office travel, family tours, educational trips, and airport transfers from Kharadi Pune. Comfortable seating and elegant interiors ensure pleasant travel experiences suitable for business and leisure travel. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from IT parks, offices, hotels, and commercial locations across Kharadi Pune. Flexible booking options allow convenient luxury bus reservations."
  },
  {
    name: "Luxury Bus On Rent in Yerawada Pune",
    description: "Luxury bus on rent in Yerawada Pune service provides stylish and spacious transportation for sightseeing tours, wedding functions, airport transfers, and outstation journeys. Premium seating and smooth highway performance ensure comfortable travel experiences suitable for large passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and commercial areas across Yerawada Pune. Flexible booking options allow convenient luxury bus reservations."
  },
  {
    name: "Luxury Bus On Rent in Vishrantwadi Pune",
    description: "Luxury bus on rent in Vishrantwadi Pune service offers reliable premium transportation for family vacations, corporate events, educational tours, and tourist travel requirements. Spacious interiors and luxury seating ensure smooth travel experiences suitable for local and outstation journeys. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and commercial locations across Vishrantwadi Pune. Flexible booking options allow convenient luxury bus reservations."
  },
  {
    name: "14 17 20 25 Seater Luxury Bus On Rent Pune",
    description: "14 17 20 25 seater luxury bus on rent Pune service provides multiple premium seating options for family tours, airport transfers, corporate travel, weddings, and outstation journeys. Comfortable luxury interiors and spacious seating ensure pleasant travel experiences suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient luxury bus reservations."
  },
  {
    name: "32 35 40 45 Seater Luxury Bus Hire in Pimpri Chinchwad",
    description: "32 35 40 45 seater luxury bus hire in Pimpri Chinchwad service offers spacious premium transportation for school tours, corporate outings, wedding functions, pilgrimage travel, and tourist journeys. Luxury seating and modern interiors ensure smooth highway travel suitable for large passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and commercial locations across Pimpri Chinchwad Pune. Flexible booking options allow convenient luxury bus hire reservations."
  },
  {
    name: "Luxury Bus On Rent in Hadapsar Pune",
    description: "Luxury bus on rent in Hadapsar Pune service provides premium transportation for airport transfers, family outings, office travel, wedding functions, and outstation journeys from Hadapsar Pune. Spacious seating and elegant interiors ensure comfortable travel experiences suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial areas across Hadapsar Pune. Flexible booking options allow convenient luxury bus reservations."
  },
  {
    name: "Luxury Bus on Rent for Picnic in Pune",
    description: "Luxury bus on rent for picnic in Pune service offers comfortable premium transportation for school outings, office day trips, family gatherings, and sightseeing tours. Spacious luxury seating and smooth highway performance ensure pleasant journeys suitable for all age groups and group passengers. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, schools, colleges, offices, and residential societies across Pune. Flexible booking options allow convenient luxury picnic bus reservations."
  },
  {
    name: "Mini Luxury Bus Hire in Pune",
    description: "Mini luxury bus hire in Pune service provides stylish and spacious transportation for airport transfers, wedding travel, family vacations, local sightseeing, and business trips. Comfortable luxury interiors ensure smooth travel experiences suitable for small and medium-sized passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient mini luxury bus reservations."
  },
  {
    name: "Luxury Bus for Corporate Events Pune",
    description: "Luxury bus for corporate events Pune service offers professional premium transportation for conferences, seminars, office meetings, employee travel, and business functions. Spacious luxury buses ensure comfortable travel experiences suitable for executive teams and corporate passengers. Professional drivers ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial areas across Pune. Flexible booking options allow convenient corporate luxury bus reservations."
  },
  {
    name: "Luxury Bus for Wedding Pune",
    description: "Luxury bus for wedding Pune service provides luxurious transportation for wedding guests, bridal parties, family members, and marriage function travel requirements. Spacious seating and elegant interiors ensure smooth travel experiences suitable for wedding ceremonies and celebrations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the wedding schedule. Pickup services are available from homes, banquet halls, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient wedding luxury bus reservations."
  },
  {
    name: "Luxury Bus for Outstation Pune",
    description: "Luxury bus for outstation Pune service offers premium long-distance transportation for Goa tours, Mahabaleshwar trips, Konkan Darshan, pilgrimage journeys, and family vacations. Spacious seating and smooth highway performance ensure comfortable travel experiences suitable for large passenger groups. Professional drivers ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient outstation luxury bus reservations."
  },
  {
    name: "Luxury Bus for Family Trip Pune",
    description: "Luxury bus for family trip Pune service provides comfortable transportation for holiday vacations, sightseeing journeys, pilgrimage travel, and group tours with relatives and family members. Spacious seating and luggage capacity ensure smooth travel experiences suitable for local and outstation family trips. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and residential areas across Pune. Flexible booking options allow convenient family trip luxury bus reservations."
  },
  {
    name: "Luxury Bus for Airport Transfer Pune",
    description: "Luxury bus for airport transfer Pune service offers dependable premium transportation for tourist groups, wedding guests, office teams, and family passengers traveling to and from airport terminals. Spacious buses ensure comfortable luggage handling and smooth airport journeys suitable for large passenger groups. Professional chauffeurs ensure timely airport pickups and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient airport luxury bus reservations."
  },
  {
    name: "Luxury Bus for Group Travel Pune",
    description: "Luxury bus for group travel Pune service provides spacious premium transportation for sightseeing tours, educational trips, office outings, pilgrimage journeys, and tourist travel requirements. Comfortable seating and elegant interiors ensure pleasant travel experiences suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient group travel luxury bus reservations."
  },
  {
    name: "Luxury Bus for School Picnic Pune",
    description: "Luxury bus for school picnic Pune service offers safe and comfortable premium transportation for educational tours, student outings, school travel, and one-day picnic trips. Spacious luxury seating and smooth highway performance ensure pleasant travel experiences suitable for students, teachers, and educational groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from schools, colleges, coaching institutes, homes, and educational campuses across Pune. Flexible booking options allow convenient school picnic luxury bus reservations."
  },
  {
    name: "Premium Bus Rental Pune",
    description: "Premium bus rental Pune service provides reliable luxury transportation for weddings, corporate travel, educational tours, airport transfers, sightseeing journeys, and outstation trips. Spacious buses with modern interiors ensure comfortable travel experiences suitable for all passenger groups and travel requirements. Professional chauffeurs ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient premium bus reservations."
  },
  {
    name: "Luxury Tourist Bus Pune",
    description: "Luxury tourist bus Pune service offers premium transportation for sightseeing tours, family vacations, pilgrimage travel, educational trips, and group tourism. Comfortable seating and spacious interiors ensure smooth highway travel suitable for tourists and travel groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient tourist bus reservations."
  },
  {
    name: "Luxury Bus Booking Pune",
    description: "Luxury bus booking Pune service provides premium transportation solutions for weddings, corporate events, airport transfers, tourist travel, and outstation journeys. Spacious buses with elegant interiors ensure pleasant travel experiences suitable for large passenger groups and luxury travel requirements. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient luxury bus booking reservations."
  }
],

tableData: [
  ["Luxury Bus Rental in Pimpri Chinchwad", "Luxury Bus Rental in Kharadi"],
  ["Luxury Bus On Rent in Yerawada Pune", "Luxury Bus On Rent in Vishrantwadi Pune"],
  ["14 17 20 25 Seater Luxury Bus On Rent Pune", "32 35 40 45 Seater Luxury Bus Hire in Pimpri Chinchwad"],
  ["Luxury Bus On Rent in Hadapsar Pune", "Luxury Bus on Rent for Picnic in Pune"],
  ["Mini Luxury Bus Hire in Pune", "Luxury Bus for Corporate Events Pune"],
  ["Luxury Bus for Wedding Pune", "Luxury Bus for Outstation Pune"],
  ["Luxury Bus for Family Trip Pune", "Luxury Bus for Airport Transfer Pune"],
  ["Luxury Bus for Group Travel Pune", "Luxury Bus for School Picnic Pune"],
  ["Premium Bus Rental Pune", "Luxury Tourist Bus Pune"],
  ["Luxury Bus Booking Pune", "Luxury Bus Rental in Pimpri Chinchwad"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Non AC Bus Rental Service in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable non AC bus rental service in Pune with comfortable seating, professional drivers, and smooth travel arrangements for group tours, school trips, and corporate travel."
      },
      {
        WhyChooseheading: "Affordable Non AC Bus Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable non AC bus rental packages in Pune with transparent pricing, budget-friendly travel options, and complete booking support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Non AC Bus Booking Service",
        WhyChoosedescription: "Our non AC bus rental service in Pune operates 24 hours for school tours, wedding transportation, employee travel, picnic trips, pilgrimage journeys, and outstation group travel."
      },
      {
        WhyChooseheading: "Comfortable & Spacious Non AC Buses",
        WhyChoosedescription: "All non AC buses provided by Aaradhya Travels are spacious, clean, regularly maintained, and designed to provide safe and comfortable travel experiences for large groups."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Group Travel Plans",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, multi-day outstation journeys, and flexible travel packages according to customer requirements."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Bus Options",
        WhyChoosedescription: "Customers can choose from different seating capacity non AC buses suitable for school groups, wedding guests, office teams, tourists, and family travel."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides doorstep pickup from homes, schools, offices, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, Pimpri, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Group Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is non AC bus rental service in Pune?", answer: "Non AC bus rental service in Pune provides budget-friendly group transportation for school trips, corporate travel, family tours, weddings, and outstation journeys." },
    { question: "Is non AC bus booking available 24 hours?", answer: "Yes, Aaradhya Travels provides 24/7 non AC bus rental service in Pune." },
    { question: "Which seating capacity non AC buses are available?", answer: "Aaradhya Travels offers non AC buses with multiple seating capacities suitable for small and large group travel." },
    { question: "Can I book non AC buses for outstation travel?", answer: "Yes, customers can book non AC buses for outstation tours, pilgrimage journeys, school trips, and holiday travel." },
    { question: "Do you provide non AC buses for school and corporate trips?", answer: "Yes, Aaradhya Travels provides non AC bus rental service for school tours, office outings, conferences, and employee transportation." },
    { question: "Are all non AC buses maintained properly?", answer: "Yes, all non AC buses are regularly cleaned and maintained for safe and comfortable group travel." },
    { question: "Can I book non AC bus rental service online in Pune?", answer: "Yes, customers can easily book non AC bus rental service online or through phone booking." },
    { question: "Do you provide buses for weddings and family functions?", answer: "Yes, Aaradhya Travels provides spacious non AC buses suitable for weddings, family tours, and group events." },
    { question: "Are non AC bus rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for non AC bus rental?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Prashant Bendre",
    feedback:
      "A non AC bus rental service in Pune worked well for our large group travel. The vehicle was spacious, clean, and ensured a comfortable journey for everyone at an affordable cost.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Shinde",
    feedback:
      "We used a non AC bus rental service in Pune for a community trip and the experience was smooth. The bus was well-maintained and perfectly suitable for short-distance group travel.",
    rating: 5
  }
];






  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Bus Rental in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/luxury-bus-rental-in-pune.jpg",
  "description": "Book Luxury Bus Rental in Pune with Aaradhya Travels for weddings, corporate events, airport transfers, family trips, picnics, and outstation travel. Available in 14, 17, 20, 25, 32, 35, 40, and 45 seater luxury buses across Pune and nearby areas.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2896"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/luxury-bus-rental-in-pune"
  }
};






  return (
    <div>

<Helmet>
  <title>
    Luxury Bus Rental in Pune | Premium AC Bus Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Luxury Bus Rental in Pune with Aaradhya Travels. Premium AC luxury buses available for weddings, corporate events, airport transfers, picnics, family trips, and outstation travel in all seating capacities."
  />

  <meta
    name="keywords"
    content="Luxury Bus Rental in Pimpri Chinchwad, Luxury Bus Rental in Kharadi, Luxury Bus On Rent in Yerawada Pune, Luxury Bus On Rent in Vishrantwadi Pune, 14 17 20 25 Seater Luxury Bus On Rent Pune, 32 35 40 45 Seater Luxury Bus Hire in Pimpri Chinchwad, Luxury Bus On Rent in Hadapsar Pune, Luxury bus on rent for picnic in Pune, Mini luxury bus hire in Pune, Luxury Bus for Corporate Events Pune, Luxury Bus for Wedding Pune, Luxury Bus for Outstation Pune, Luxury Bus for Family"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/17.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxurybusrentalinpune;